const heroVideo = {
	el: {
		heroVideoContainers: document.querySelectorAll('.js-bg-video')
	},

	init() {
		if(!this.el.heroVideoContainers) return
		for(const video of this.el.heroVideoContainers) {
			video.load()
			videoHelper.fxFetchVideo(video)
		}
	}
}

heroVideo.init()